<!-- Header using PrimeNG Toolbar - Fixed at top -->
<p-toolbar class="border-b flex-shrink-0">
  <div class="flex items-center justify-between w-full gap-2">
    <!-- Start: Menu Button -->
    <div class="flex items-center gap-3 flex-shrink-0">
      <p-button
        icon="pi pi-bars"
        [rounded]="true"
        size="small"
        (onClick)="onMenuToggle()"
        [ariaLabel]="'home.toggleMenu' | translate"
      />
    </div>

    <!-- Center: Title and Subtitle -->
    <div class="flex flex-col items-center text-center px-2 flex-1 min-w-0">
      @if (headerService.loading()) {
      <!-- Skeleton for title -->
      <p-skeleton
        width="10rem"
        height="1.25rem"
        class="mb-2 md:mb-2 md:!w-[15rem] md:!h-[1.5rem]"
      />
      <!-- Skeleton for subtitle -->
      <p-skeleton width="12rem" height="0.875rem" class="md:!w-[20rem] md:!h-[1rem]" />
      } @else { @if (headerService.title()) {
      <h1 class="text-base md:text-xl font-semibold truncate max-w-full">
        {{ headerService.title() }}
      </h1>
      } @if (headerService.subtitle()) {
      <p class="text-xs md:text-sm text-secondary truncate max-w-full">
        {{ headerService.subtitle() }}
      </p>
      } }
    </div>

    <!-- End: Save Indicator and Buttons -->
    <div class="flex items-center gap-2 md:gap-4 flex-shrink-0">
      <!-- Save Indicator -->
      @if (headerService.saveIndicator()) {
      <div class="hidden lg:flex items-center gap-2 text-sm">
        @switch (headerService.saveIndicator()!.status) { @case ('unsaved') {
        <i class="pi pi-circle-fill text-amber-500" style="font-size: 0.5rem"></i>
        <span class="text-secondary">{{ 'common.unsaved' | translate }}</span>
        } @case ('saving') {
        <i class="pi pi-spin pi-spinner text-primary" style="font-size: 0.875rem"></i>
        <span class="text-secondary">{{ 'common.saving' | translate }}</span>
        } @case ('saved') {
        <i class="pi pi-check-circle text-green-500" style="font-size: 0.875rem"></i>
        <span class="text-secondary"
          >{{ 'common.savedAt' | translate }}:
          {{ formatSaveTime(headerService.saveIndicator()!.lastSavedAt!) }}</span
        >
        } }
      </div>
      }

      <!-- Buttons -->
      @if (headerService.loading()) {
      <!-- Skeleton for buttons -->
      <p-skeleton width="2.5rem" height="2.5rem" borderRadius="6px" class="md:hidden" />
      <p-skeleton width="6rem" height="2.5rem" borderRadius="6px" class="hidden md:block" />
      <p-skeleton width="6rem" height="2.5rem" borderRadius="6px" class="hidden md:block" />
      } @else {
      <div class="flex items-center gap-1 md:gap-2">
        @for (button of headerService.buttons(); track $index) {
        <!-- Mobile: Icon-only buttons -->
        @if ($index < headerService.buttons().length - 1) {
        <p-button
          class="md:hidden"
          [icon]="button.icon"
          [severity]="button.severity || 'primary'"
          [outlined]="button.outlined || false"
          [disabled]="button.disabled || false"
          [loading]="button.loading || false"
          [text]="true"
          [rounded]="true"
          [attr.aria-label]="button.label"
          (onClick)="button.action()"
        />
        <!-- Desktop: Full buttons -->
        <p-button
          class="hidden md:inline-flex"
          [label]="button.label"
          [icon]="button.icon"
          [severity]="button.severity || 'primary'"
          [outlined]="button.outlined || false"
          [disabled]="button.disabled || false"
          [loading]="button.loading || false"
          (onClick)="button.action()"
        />
        } @else {
        <!-- Last button: Icon-only on mobile, full on desktop -->
        <p-button
          class="md:hidden"
          [icon]="button.icon"
          [severity]="button.severity || 'primary'"
          [disabled]="button.disabled || false"
          [loading]="button.loading || false"
          [rounded]="true"
          [attr.aria-label]="button.label"
          (onClick)="button.action()"
        />
        <p-button
          class="hidden md:inline-flex"
          [label]="button.label"
          [icon]="button.icon"
          [severity]="button.severity || 'primary'"
          [outlined]="button.outlined || false"
          [disabled]="button.disabled || false"
          [loading]="button.loading || false"
          (onClick)="button.action()"
        />
        } }
      </div>
      }
    </div>
  </div>
</p-toolbar>
